<template>
  <div class="d-flex flex-column">
    <span class="text-capitalize-first">
      {{ helper.trans(`antifraudalerts.rule.${alert.rule}`) }}
    </span>
    <div class="text-danger">
      <i class="fa fa-warning"></i>
      <span class="text-capitalize-first">{{ helper.trans(`antifraudalerts.description.${alert.rule}.default`) }}</span>
    </div>
    <div class="small text-secondary mt-1">
      <span class="text-capitalize-first">{{ helper.trans('antifraudalerts.description.active_disputes_count_check.threshold') }}: {{ data?.threshold }}</span>
      <span class="mx-1">|</span>
      <span class="text-capitalize-first">{{ helper.trans('antifraudalerts.description.active_disputes_count_check.pay_in_count') }}: {{ data?.payInCount }}</span>
      <span class="mx-1">|</span>
      <span class="text-capitalize-first">{{ helper.trans('antifraudalerts.description.active_disputes_count_check.pay_out_count') }}: {{ data?.payOutCount }}</span>
      <span class="mx-1">|</span>
      <span class="text-capitalize-first">{{ helper.trans('antifraudalerts.description.active_disputes_count_check.pay_in_blocked') }}: {{ data?.payInBlocked ? helper.trans('antifraudalerts.description.active_disputes_count_check.yes') : helper.trans('antifraudalerts.description.active_disputes_count_check.no') }}</span>
      <span class="mx-1">|</span>
      <span class="text-capitalize-first">{{ helper.trans('antifraudalerts.description.active_disputes_count_check.pay_out_blocked') }}: {{ data?.payOutBlocked ? helper.trans('antifraudalerts.description.active_disputes_count_check.yes') : helper.trans('antifraudalerts.description.active_disputes_count_check.no') }}</span>
    </div>
  </div>
</template>

<script lang="ts">

import {computed, defineComponent, Prop, PropType} from 'vue'
import {helper} from "@/service/CommonHelper";
import AntiFraudAlertDTO from "@/models/AntiFraudAlertDTO";
import ActiveDisputesCountCheckDataDTO from "@/models/AntiFraud/ActiveDisputesCountCheckDataDTO";

export default defineComponent({
  name: "ActiveDisputesCountCheckDescription",
  props: {
    alert: {
      type: Object as PropType<AntiFraudAlertDTO>,
      default: null
    } as Prop<AntiFraudAlertDTO>,
  },
  setup(props) {
    const data = computed((): ActiveDisputesCountCheckDataDTO | null => {
      if (!props.alert) {
        return null
      }

      return props.alert.data as unknown as ActiveDisputesCountCheckDataDTO
    })

    return {
      helper,
      data
    }
  }
})
</script>
